import { apiFetch } from '@/shared/api/client'
import type { DelmanDeviceBinding } from '@/shared/auth/delmanDeviceStorage'

import { isMockApi } from '@/shared/env'
export type DelmanActivationPreview = {
  device_name: string
  kitchen_name: string
  delman_name: string
  device_type: 'delman_mobile'
}

export type ActivateDelmanRequest = {
  activation_code: string
  device_uid: string
  os?: string
}

export type ActivateDelmanResponse = {
  device_id: string
  device_uid: string
  device_name: string
  device_type: 'delman_mobile'
  kitchen_id: string
  kitchen_name: string
  delman_id: string
  delman_name: string
}

const MOCK_CODE = 'D7LM9P'

function useMockApi(): boolean {
  return isMockApi
}

function mockPreview(code: string): DelmanActivationPreview {
  if (!code.trim()) {
    throw new Error('Kode tidak valid atau sudah kedaluwarsa.')
  }
  if (code === MOCK_CODE) {
    return {
      device_name: 'HP Budi',
      kitchen_name: 'Dapur A',
      delman_name: 'Budi Santoso',
      device_type: 'delman_mobile',
    }
  }
  const suffix = code.replace(/[^A-Z0-9]/g, '').slice(-4) || '0001'
  return {
    device_name: `HP Delman ${suffix}`,
    kitchen_name: 'Dapur A',
    delman_name: 'Budi Santoso',
    device_type: 'delman_mobile',
  }
}

function mockActivate(req: ActivateDelmanRequest): ActivateDelmanResponse {
  const preview = mockPreview(req.activation_code)
  return {
    device_id: `dev-delman-${req.device_uid.slice(0, 8)}`,
    device_uid: req.device_uid,
    device_name: preview.device_name,
    device_type: 'delman_mobile',
    kitchen_id: 'kitchen-dapur-a',
    kitchen_name: preview.kitchen_name,
    delman_id: 'delman-budi',
    delman_name: preview.delman_name,
  }
}

export function toDelmanBinding(res: ActivateDelmanResponse): DelmanDeviceBinding {
  return {
    deviceId: res.device_id,
    deviceUid: res.device_uid,
    deviceName: res.device_name,
    delmanId: res.delman_id,
    delmanName: res.delman_name,
    kitchenId: res.kitchen_id,
    kitchenName: res.kitchen_name,
    deviceType: res.device_type,
    activatedAt: new Date().toISOString(),
  }
}

export async function lookupDelmanActivationCode(code: string): Promise<DelmanActivationPreview> {
  if (useMockApi()) {
    await new Promise((r) => setTimeout(r, 350))
    return mockPreview(code)
  }

  const encoded = encodeURIComponent(code)
  return apiFetch<DelmanActivationPreview>(`/auth/activation-codes/preview?code=${encoded}`)
}

export async function activateDelmanDevice(req: ActivateDelmanRequest): Promise<DelmanDeviceBinding> {
  if (useMockApi()) {
    await new Promise((r) => setTimeout(r, 1200))
    return toDelmanBinding(mockActivate(req))
  }

  const res = await apiFetch<ActivateDelmanResponse>('/auth/activate-device', {
    method: 'POST',
    body: JSON.stringify(req),
  })
  return toDelmanBinding(res)
}
